
import { Input } from "../../../components/ui/input";
import { Search } from "lucide-react";
import Table1 from "../../../components/table/table-1";
import { columns, data } from "../../../data/patient/report/download-report"

const DownloadReport = () => {

    return (
        <div className="p-2">
            <div className="text-2xl md:text-3xl text-gray-900 font-semibold mb-6 md:mb-8">
                Download Medical Reports
            </div>
             <div className="w-full mb-4">
                <div className="">
                    <div className="relative w-full">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4" />
                        <Input
                            type="search"
                            placeholder="Enter Pincode (e.g.-842001) and Name"
                            className="pl-9"
                        />
                    </div>
                </div>
            </div>
            <Table1 columns={columns} data={data} rowsPerPage={4} />
        </div>
    );
};

export default DownloadReport;
